import React from 'react'
import { useSelector } from 'react-redux'

import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const DraftsContainer = ({ openPage }) => {
  const { inchat: { drafts, scheduled } } = useSelector(store => store)

  return (
    <div className='inchat-container inchat-draft-container'>
      <div className='inchat-container__header' onClick={() => openPage('drafts')}>
        <img src={getStaticImage('/icons/orange-brand/icon-drafts.svg')} alt='drafts' />
        <div className='inchat-container__header-content'>
          <p title={lang('dashboard_drafts-scheduled')} className='inchat-container__title text-ellipsis'>
            {lang('dashboard_drafts-scheduled')}
          </p>
          {drafts > 0 ? (
            <div title={lang('dashboard_drafts')} className='inchat-container__count'>
              <span>{drafts}</span>
            </div>
          ) : null}
          {scheduled?.count ? (
            <div title={lang('dashboard_scheduled-messages')} className='inchat-container__count'>
              <span>{scheduled.count}</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default DraftsContainer
